import React, {Component, Fragment} from 'react';

import CloseIcon from "../../assets/img/close.png";
import PropTypes from "prop-types";
import {choicesToMake} from "../../helpers/policyChoiceHelper";
import history from "../../history";
import PopUp from "./PopUp";
import {connect} from "react-redux";

const desktop = document.querySelector('#root').clientWidth >= 1240;

class GoBackButton extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
    closeWindow: PropTypes.bool,
    customHandler: PropTypes.func,
  };
  static defaultProps = {
    closeWindow: false,
    forceLocation: false,
    customHandler: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      popupId: null,
    };
    this.goBack = this.goBack.bind(this);
  }

  handlePolicyPopup = () => {
    const polChoicesToMake = choicesToMake(this.props.policyChoice, this.props.gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices);
    if(polChoicesToMake > 0) {
      this.setState({
        showPopup: true,
        popupId: 'mlgmstap3beleidskeuzes',
      })
    } else {
      this.goBack(null, true);
    }
  }

  closePopup = (answer) => {
    this.setState({
      showPopup: false,
      popupId: null,
    })
    if(!answer) {
      this.goBack(null,true);
    }
  }

  goBack(ev, accepted = false) {
    if(
        this.props.gameState.activatedStep === 3 &&
        this.props.project.difficulty === 'BASIC' &&
        history.location.pathname.startsWith('/beleidskeuzes')
    ) {
      if(!accepted) {
        this.handlePolicyPopup();
      } else {
        if(sessionStorage.getItem('toMin') === "list"){
          this.props.history.push('/ministries');
        } else {
          this.props.history.push('/');
        }
      }
      return;
    }

    if(history.location.pathname.startsWith('/bank')) {
      const target = sessionStorage.getItem('prevLocation');
      if(target) {
        this.props.history.push(target);
        return;
      }
    }

    if (typeof this.props.onClick === 'function') {
      if (this.props.onClick()) {
        return;
      }
    }
    if (this.props.closeWindow) {
      window.close();
      return;
    }

    const path = this.props.history.location.pathname;

    if (this.props.customHandler) {
      this.props.customHandler();
      return;
    }

    if (this.props.forceLocation) {
      this.props.history.push(this.props.forceLocation);
    } else if (desktop && path.indexOf('portal') === -1) {
      this.props.history.push('/');
    } else if (path.indexOf('bank') !== -1) {
      this.props.history.push(window.sessionStorage.getItem('prevLocation'));
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    return (
      <Fragment>
        <div onClick={this.goBack} className="close-button">
          <span className="close-icon">
            <img src={CloseIcon} height='15' alt=''/>
          </span>
        </div>
        { this.state.showPopup ? (
          <PopUp id={this.state.popupId} closePopUpClick={(res) => {this.closePopup(res)}}/>
        ) : null }
      </Fragment>
    )
  }
}
export default connect(({policyChoice, gameStateInput, project, feedback, gameState}) => ({policyChoice, gameStateInput, project, feedback, gameState}))(GoBackButton);



// WEBPACK FOOTER //
// ./src/components/elements/GoBackButton.js